import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { dbObjectToId } from '@nu-art/ts-common';
import { Permissions_DropDown } from '../../ui-props.js';
import { TS_Icons } from '@nu-art/ts-styles';
import { ModuleFE_PermissionAccessLevel, ModuleFE_PermissionDomain } from '../../../_entity.js';
export class Component_AccessLevelsEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const levelIds = nextProps.permissionKey.get().accessLevelIds ?? [];
        state.levels = ModuleFE_PermissionAccessLevel.cache.filter(i => levelIds.includes(i._id));
        return state;
    }
    renderTag(level) {
        return _jsxs("div", { className: 'level', children: [_jsx(Button, { variant: 'dangerous', onClick: async () => {
                        const levels = this.state.levels.filter(i => i._id !== level._id);
                        await this.props.permissionKey.set({ accessLevelIds: levels.map(dbObjectToId) });
                        this.reDeriveState();
                    }, children: _jsx(TS_Icons.x.component, {}) }), _jsx("span", { children: level.name })] }, level._id);
    }
    renderLevelDropDown = () => {
        return _jsx(Permissions_DropDown.AccessLevel, { queryFilter: (item) => {
                return !this.state.levels.map(i => i._id).includes(item._id);
            }, mapper: level => {
                const domain = ModuleFE_PermissionDomain.cache.unique(level.domainId);
                return [domain.namespace, level.name, String(level.value)];
            }, className: 'access-levels-dropdown', selected: undefined, onSelected: async (level) => {
                const levels = [...this.state.levels, level];
                await this.props.permissionKey.set({ accessLevelIds: levels.map(dbObjectToId) });
                this.reDeriveState();
            }, placeholder: 'New Access Level', caret: {
                open: _jsx("div", { className: 'caret open', children: _jsx(TS_Icons.treeCollapse.component, { style: { rotate: '90' } }) }),
                close: _jsx("div", { className: 'caret close', children: _jsx(TS_Icons.treeCollapse.component, { style: { rotate: '-90' } }) }),
            }, boundingParentSelector: '.ts-tabs__content' });
    };
    render() {
        return (_jsx(LL_V_L, { className: 'access-levels-section', children: _jsxs(LL_V_L, { className: 'access-levels', children: [this.state.levels.map(level => this.renderTag(level)), this.renderLevelDropDown()] }) }));
    }
}
//# sourceMappingURL=Component_AccessLevelsEditor.js.map